import React, { useContext } from "react";
import {
  Button,
  ButtonGroup,
  Icon,
  IconSettings,
  PageHeader,
  PageHeaderControl,
} from "@salesforce/design-system-react";
import RelatedSection from "./RelatedSection";

import { MessagesContext } from "../context/messagesContext";

const SalesforceObjectDisplay = ({ record }) => {
  const { displaySalesforceEdit } = useContext(MessagesContext);

  const actions = () => (
    <React.Fragment>
      <PageHeaderControl>
        <ButtonGroup variant="list" id="button-group-page-header-actions">
          <Button
            label="Edit"
            onClick={() => displaySalesforceEdit(record.type, record.id)}
          />
          <Button label="Linked to" disabled />
          <Button
            label="View in Salesforce"
            onClick={() => window.open(record.links.viewInSalesforce, "_blank")}
          />
        </ButtonGroup>
      </PageHeaderControl>
    </React.Fragment>
  );

  const renderRelated = record.related.map((obj, index) => {
    return (
      <div className="slds-p-top_small related-section-header" key={index}>
        <RelatedSection obj={obj} key={index} />
      </div>
    );
  });

  return (
    <IconSettings iconPath="/icons">
      <PageHeader
        details={record.details}
        icon={
          <Icon
            assistiveText={{ label: record.title }}
            category="standard"
            name={record.iconType}
          />
        }
        label={record.type}
        onRenderActions={actions}
        title={record.title}
        variant="record-home"
      />
      {renderRelated}
    </IconSettings>
  );
};

export default SalesforceObjectDisplay;
